import type { FiltersGroup } from '#src/lib/filters.ts';

import type { FilterConfig } from './useGQLSearch.ts';

export function pickRenderedBackendFilters(
  filterConfig: FilterConfig,
  filtersGroups: FiltersGroup[]
): FilterConfig {
  const widgetAttributes = new Set(
    filtersGroups
      .flatMap(group => [
        ...group.filters,
        ...(group.filter ? [group.filter] : []),
      ])
      .flatMap((f): string[] => {
        if ('attribute' in f) {
          return [f.attribute as string, ...(f.subAttributes ?? [])];
        }
        if ('filter' in f) {
          const name = (f as unknown as { filter?: { name?: string } }).filter
            ?.name;
          return name ? [name] : [];
        }
        return [];
      })
  );

  return Object.fromEntries(
    Object.entries(filterConfig).filter(([key, config]) => {
      if (config.type === 'virtual') return true;
      if (widgetAttributes.has(key)) return true;
      const api = typeof config.api === 'string' ? config.api : null;
      return !!api && widgetAttributes.has(api);
    })
  );
}
